import config from "src/config";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/code`;

export const getCommonCodeList = async (params?: string) => {
	
  const url = `${baseUrl}/common` + (params ? `?${params}` : '');

  return await getData<ResponseDto<SysCodeDto[]>>(url);
}

export const getMinorCodeList = async (majorCode: string) => {
	
	return await getData<ResponseDto<SysCodeDto[]>>(baseUrl, {
		params: { majorCode }
	});
}

export const getConditionCodeList = async (majorCode: string) => {
	return await getData<ResponseDto<SysCodeDto[]>>(`${baseUrl}/${majorCode}`);
}

export const getMajorCodeOptions = async () => {
	return await getData<ResponseDto<SysCodeDto[]>>(`${baseUrl}/common`);
}

export const getAfeederCodeList = async () => {
	return await getData<ResponseDto<SysCodeDto[]>>(`${baseUrl}/afeeder`);
}

export const getBfeederCodeList = async () => {
	return await getData<ResponseDto<SysCodeDto[]>>(`${baseUrl}/bfeeder`);
}

export const getCfeederCodeList = async () => {
	return await getData<ResponseDto<SysCodeDto[]>>(`${baseUrl}/cfeeder`);
}